<template>
  <div>
    <div class="deviceManagement">
      <CommonForm
        :form="form"
        :searchItems="searchItems"
        @search="handleSearchChange"
        @clear="clear"
        @taskTypeChange="taskTypeChange"
      />
      <!-- <div class="operate-box">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="showUpload = true"
        >
          导入
        </el-button>
        <el-button icon="el-icon-download" size="small" @click="handleExport">
          下载
        </el-button>
      </div> -->
      <CommonTable
        ref="listRef"
        v-loading="loading"
        :columns="columns"
        :tableData="tableData"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template v-slot:index="row">
          <span>{{ row }}</span>
        </template>

        <template v-slot:videoTime="{ row }">
          <span>{{ row.videoTime + 's'}}</span>
        </template>

        <template v-slot:actions="{ row }">
          <el-button type="text" size="small" @click="handleVideo(row)">
            预览
          </el-button>
          <el-button type="text" size="small" @click="handleDown(row)">
            下载
          </el-button>
        </template>
      </CommonTable>
      <VideoDialog ref="videoRef"></VideoDialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import CommonForm from "@/components/CommonForm";
import VideoDialog from "@/components/VideoDialog";

import { getFeedbackVideo, getTrainType, downloadVideo, getSportType } from "@/api/index";
import { FEEDBACK_STATUS, CALC_MODE } from "@/constants/index";
import dayjs from "dayjs";
export default {
  components: {
    CommonTable,
    CommonForm,
    VideoDialog,
  },
  data() {
    return {
      columns: [
        // { prop: "userId", label: "用户id" },
        // { prop: "taskId", label: "任务id" },
        { prop: "taskTypeName", label: "任务类型" },
        { prop: "sportName", label: "运动类型" },
        { prop: "modelName", label: "训练模式" },
        { prop: "videoTime", label: "视频时长" },
        { prop: "videoCreateTime", label: "回流时间" },
        { prop: "actions", label: "操作" },
      ],
      tableData: [
        {
          videoUrl: "https://oss-mrjz-prd.oss-cn-shanghai.aliyuncs.com/dev/mrjz-video/2022-09-22/63_2AA_1_1_20220920143560602.mp4",
        },
      ],
      trainTypeArr: [], // 训练类型
      sprotTypeArr: [], // 运动类型
      form: {},
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      loading: false,
    };
  },
  computed: {
    searchItems() {
      return [
        {
          type: "select",
          value: "taskType",
          label: "任务类型",
          options: [
            {
              label: "训练",
              value: "training",
            },
            {
              label: "挑战",
              value: "challenge",
            },
          ],
        },
        {
          type: "select",
          value: "sportId",
          label: "运动类型",
          options: this.sprotTypeArr,
        },
        {
          type: "select",
          value: "modelCode",
          label: "训练模式",
          options: this.trainTypeArr,
        },
        // {
        //   type: "input",
        //   value: "userId",
        //   label: "用户id",
        // },
        // {
        //   type: "input",
        //   value: "taskId",
        //   label: "任务id",
        // },
      ];
    },
  },
  mounted() {
    // this.getSportTypeReq();
    this.getTrainTypeReq();
    this.getData();
  },
  methods: {
    // 任务类型改变
    taskTypeChange(type) {
      if(type) {
        this.getSportTypeReq(type)
      } else {
        this.sprotTypeArr = []
      }
    },
    // 清除某一个条件出触发搜索
    clear(values) {
      this.form = values;
      this.getData();
    },
    // 获取训练类型
    getTrainTypeReq() {
      getTrainType().then((res) => {
        const { data = [] } = res;
        this.trainTypeArr = data.map((item) => ({
          value: item.type,
          label: item.name,
        }));
      });
    },
    // 获取运动类型
    getSportTypeReq(type = "") {
      getSportType(type).then((res) => {
        const { data = [] } = res;
        this.sprotTypeArr = data.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      })
    },
    getData() {
      const { page, size } = this.pagination;
      this.loading = true;
      getFeedbackVideo({
        page: page,
        size: size,
        ...this.form,
      }).then((res) => {
        const {
          data: { list = [], total },
        } = res;
        this.pagination.total = total;
        this.tableData = list;
        this.loading = false;
      });
    },
    gotoPage(val) {
      this.pagination.page = val;
      this.getData();
    },
    // 下载视频
    async handleDown(item) {
      const videoUrl = item.videoUrl;
      try {
        // 使用 fetch 请求视频文件并获取二进制数据
        const response = await fetch(videoUrl);
        if (!response.ok) throw new Error('视频下载失败');
        
        const videoBlob = await response.blob();
        const videoUrlBlob = URL.createObjectURL(videoBlob);

        // 创建并点击下载链接
        const a = document.createElement('a');
        a.href = videoUrlBlob;
        a.download = `视频_${dayjs().format("YYYYMMDDHHmm")}.mp4`;
        a.click();

        // 清理
        URL.revokeObjectURL(videoUrlBlob);
      } catch (error) {
        console.error(error.message);
      }
    },
    // 搜索
    handleSearchChange(values) {
      this.form = values;
      this.gotoPage();
    },
    // 列表页码切换
    handleTableChange({ page, pageSize }) {
      this.pagination.page = page;
      this.pagination.pageSize = pageSize;
      this.getData();
    },
    // 查看视频
    handleVideo(item) {
      this.$refs.videoRef.init({
        videoUrl: item.videoUrl,
        // poster: item.poster,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.deviceManagement {
  .operate-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
}
</style>
